import XAxis from './XAxis'

export default XAxis



// WEBPACK FOOTER //
// ./src/legacy/containers/Graphs/components/XAxis/index.js